import { type WpCartMobileMediaQuery } from '@cart-ui/WpCartLayout/useWpCartResponsive'
import { Divider } from '@pets-ui/Divider/Divider'
import { type HStackProps } from '@pets-ui/HStack/HStack'
import { HStack } from '@pets-ui/HStack/HStack'
import { useResponsiveCustom } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { Children, type ReactNode } from 'react'

const MOBILE: WpCartMobileMediaQuery = '@media (max-width: 983px)'

const MOBILE_ACTION_WIDTH = 30

const style = stylex.create({
  item: {
    display: 'flex',
    justifyContent: 'center',
  },
  index: {
    paddingBottom: {
      [MOBILE]: '12px',
    },
  },
  first: {
    flex: {
      [MOBILE]: '1 0 auto',
      default: '1',
    },
    maxWidth: {
      [MOBILE]: `calc(100% - ${MOBILE_ACTION_WIDTH}px)`,
    },
  },
  second: {
    flex: {
      [MOBILE]: '1',
    },
    justifyContent: {
      [MOBILE]: 'flex-start',
    },
  },
  floating: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: {
      [MOBILE]: 'absolute',
      default: 'relative',
    },
    transform: {
      [MOBILE]: 'translateY(25%)',
    },
    minWidth: {
      [MOBILE]: MOBILE_ACTION_WIDTH,
      default: 25,
    },
    right: {
      [MOBILE]: 0,
    },
    top: {
      [MOBILE]: 12,
    },
  },
})

export interface ButlerListItemLayoutProps extends HStackProps {
  children: ReactNode
}

export const ButlerListItemLayout = (props: ButlerListItemLayoutProps) => {
  const isMobile = useResponsiveCustom(MOBILE)
  const { children, ...rest } = props
  const [index, img, first, second, button, floating] = Children.toArray(children)
  return isMobile
    ? (
      <VStack>
        <div {...stylex.props(style.index)}>{index}</div>
        <Divider />
        <HStack gap={2} paddingTop={3} position="relative" flexWrap="nowrap" {...rest}>
          <div>{img}</div>
          <HStack alignItems="flex-start" gap={2} flex={1} overflow="hidden">
            <HStack alignItems="flex-end" justifyContent="space-between" width="100%" overflow="hidden" gap={1}>
              <div {...stylex.props(style.first)}>{first}</div>
              <div>{button}</div>
            </HStack>
            <div {...stylex.props(style.item, style.second)}>{second}</div>
            <div {...stylex.props(style.item, style.floating)}>{floating}</div>
          </HStack>
        </HStack>
      </VStack>
    )
    : (
      <HStack gap={4} position="relative" flexWrap="nowrap" {...rest}>
        <div>{index}</div>
        <div>{img}</div>
        <HStack alignItems="center" gap={4} flex={1} overflow="hidden">
          <div {...stylex.props(style.first)}>{first}</div>
          <div {...stylex.props(style.item, style.second)}>{second}</div>
          <div>{button}</div>
          <div {...stylex.props(style.item, style.floating)}>{floating}</div>
        </HStack>
      </HStack>
    )
}
